import { apiGet, apiPost, apiDelete, apiPut } from '../utils/api'
import Hotjar from '@hotjar/browser'

export const getPosTerminalAPI = (id) => {
  return apiGet(`mgmt/dejavoo/${id}`)
}

export const getBlazeConfigurationByShopAPI = () => {
  return apiGet('mgmt/dejavoo/getBlazeConfigurationByShop')
}

export const getPosTerminalsAPI = () => {
  return apiGet('mgmt/dejavoo/posTerminalsByShop')
}

export const getBlazePayProcessorsAPI = () => {
  return apiGet('mgmt/dejavoo/getBlazePayProcessors')
}

export const addPosTerminalAPI = (terminal) => {
  Hotjar.event('add_pos_terminal')
  return apiPost(`mgmt/dejavoo/`, terminal)
}

export const updatePosTerminalAPI = (terminal) => {
  Hotjar.event('update_pos_terminal')
  return apiPut(`mgmt/dejavoo/${terminal.id}`, terminal)
}

export const deletePosTerminalAPI = (id) => {
  Hotjar.event('delete_pos_terminal')
  return apiDelete(`mgmt/dejavoo/${id}`)
}

export const checkOnlineAPI = (terminalId, registerId) => {
  return apiGet(`mgmt/dejavoo/checkOnline/${terminalId}/${registerId}`)
}

export const getDejavooShopConfigAPI = () => {
  return apiGet('mgmt/dejavoo/current')
}

export const updateDejavooShopConfigReceiptOptionAPI = (printReceiptOption) => {
  Hotjar.event('update_dejavoo_shop_config')
  return apiPost(`mgmt/dejavoo/${printReceiptOption}`)
}



// WEBPACK FOOTER //
// ./src/api/dejavoo.js